import { Component } from '@verndale/core';
import gsap from 'gsap';
import Axios from 'axios';
import Cookies from 'js-cookie';
import {
  keyCode,
  open,
  close,
  isIE11,
  getAbsoluteCoords,
  entityPageView,
  publishEvent
} from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.scrollPosition = 0;
    this.breakpoint = matchMedia('(max-width: 1279px)');

    this.dom = {
      stickyMenu: this.el.querySelector('.header__inner'),
      openMenu: this.el.querySelector('.header__menu-open'),
      closeMenu: this.el.querySelector('.header__menu-close'),
      primaryNavigation: this.el.querySelector('.primary-navigation'),
      mainLinks: this.el.querySelector('.primary-navigation__menu'),
      submenuTriggers: this.el.querySelectorAll(
        '.primary-navigation__main-link[aria-haspopup] .primary-navigation__label'
      ),
      openSearch: this.el.querySelector('.header__search-open'),
      closeSearch: this.el.querySelector('.header__search-close'),
      searchArea: this.el.querySelector('.header-search'),
      searchInput: this.el.querySelector('.header-search__input input'),
      logout: this.el.querySelector('#logout'),
      secondarySubmenu: this.el.querySelectorAll(
        '.primary-navigation__sub-columns-menu'
      )
    };

    if (this.dom.logout) {
      this.logoutEndpoint = this.dom.logout.dataset.endpoint;

      this.hasDataAuth = document.querySelector('.body--bu');

      this.logoutParent = this.dom.logout.parentNode;
      this.logoutParent.style.display = 'none';

      if (this.hasDataAuth?.hasAttribute('data-is-user-auth')) {
        this.isAuth = this.hasDataAuth.dataset.isUserAuth.toLowerCase();

        if (this.isAuth && this.isAuth === 'true') {
          this.logoutParent.style.display = 'block';
        } else {
          this.logoutParent.style.display = 'none';
        }
      }
    }

    this.handleScroll();
    this.submenuPosition();

    if (this.dom.openSearch) {
      this.triggerPageView();
    }

    // eslint-disable-next-line no-undef
    if (typeof MatomoTagManager !== 'undefined' && typeof MatomoTagManager.dataLayer !== 'undefined' && Cookies.get('hae_cookie_preferences') === 'true') {
      // eslint-disable-next-line no-undef
      window.MatomoTagManager = window.MatomoTagManager || [];
      // eslint-disable-next-line no-undef
      window.MatomoTagManager.dataLayer.push({ 'event': 'setConsentGiven' });
      // eslint-disable-next-line no-undef
    } else if (typeof MatomoTagManager !== 'undefined' && typeof MatomoTagManager.dataLayer !== 'undefined' && Cookies.get('hae_cookie_preferences') === 'false') {
      // eslint-disable-next-line no-undef
      window.MatomoTagManager = window.MatomoTagManager || [];
      // eslint-disable-next-line no-undef
      window.MatomoTagManager.dataLayer.push({ 'event': 'setConsentDenied' });
    } else {
      null;
    }

  }

  addListeners() {
    this.dom.submenuTriggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', this.handleSubmenuOpen.bind(this));
      trigger.parentNode.addEventListener(
        'mouseleave',
        this.handleSubmenuClose.bind(this)
      );

      trigger.addEventListener('focus', this.handleSubmenuOpen.bind(this));
      trigger.parentNode.addEventListener(
        'keydown',
        this.handleSubmenuKeydown.bind(this)
      );

      trigger.addEventListener(
        'click',
        this.handleMobileSubmenuToggle.bind(this)
      );
    });
    this.dom.openMenu.addEventListener(
      'click',
      this.handleMobleMenuOpen.bind(this)
    );
    this.dom.closeMenu.addEventListener(
      'click',
      this.handleMobleMenuClose.bind(this)
    );
    if (this.dom.openSearch) {
      this.dom.openSearch.addEventListener(
        'click',
        this.handleSearchOpen.bind(this)
      );
      this.dom.closeSearch.addEventListener(
        'click',
        this.handleSearchClose.bind(this)
      );
      if (this.dom.searchInput) {
        this.dom.searchInput.addEventListener('keydown', this.handleInputKeyPress.bind(this));
      }
    }
    if (this.dom.logout) {
      this.dom.logout.addEventListener('click', this.handleLogOut.bind(this));
    }
    window.addEventListener('scroll', this.handleScroll.bind(this));
    window.addEventListener('resize', this.submenuPosition.bind(this));
  }

  async triggerPageView() {
    const { sourceId, rfkId, localeLanguage, localeCountry } = this.el.dataset;
    const { title } = document;
    if(!document.querySelector("link[rel='canonical']")) return;
    const id = `${document.querySelector("link[rel='canonical']").getAttribute("href")}`
      .replaceAll('/', '_')
      .replaceAll('.', '_')
      .replaceAll(':', '_')
      .replace(/(ja-jp|zh-cn)(_|$|\/)/g, '')
      .replaceAll(/[^a-zA-Z\d_-]/g, '_');

    await publishEvent(
      await entityPageView(
        rfkId,
        [
          {
            entity_type: 'content',
            id,
            source_id: sourceId,
            title
          }
        ],
        localeCountry,
        localeLanguage
      )
    );
  }

  submenuPosition() {
    const matchMedia = window.matchMedia('(min-width: 1280px)').matches;

    this.dom.secondarySubmenu.forEach(submenu => {
      const { x, width } = submenu.getBoundingClientRect();
      const parentWidth = submenu.parentNode.getBoundingClientRect().width;
      const windowWidth = window.innerWidth;
      const xPlusWidth = x + width;
      const isRight = () => xPlusWidth > windowWidth;

      if (matchMedia) {
        if (isRight()) {
          submenu.classList.contains('left') &&
            submenu.classList.remove('left');
          submenu.classList.add('right');
        } else if (!submenu.classList.contains('right')) {
          submenu.classList.add('left');
        }

        const leftPos = Math.ceil(parseFloat(getAbsoluteCoords(submenu).left));

        if (leftPos < 25 && !submenu.style.right) {
          const leftOffset = Math.round(Math.abs(leftPos) + 50);
          submenu.style.right = `-${leftOffset}px`;
        }
      }
    });
  }

  handleScroll() {
    if (isIE11()) {
      return;
    }

    const { stickyMenu } = this.dom;
    const direction = this.scrollPosition > window.pageYOffset ? 'up' : 'down';
    this.el.style.height = `${stickyMenu.offsetHeight}px`;
    this.scrollPosition = window.pageYOffset;

    if (direction === 'down' && this.scrollPosition > this.el.offsetHeight) {
      if (stickyMenu.style.position !== 'fixed') {
        stickyMenu.style.position = 'fixed';
      }

      if (!stickyMenu.classList.contains('header__inner--hidden')) {
        stickyMenu.classList.add('header__inner--hidden');
        stickyMenu.style.top = `-${this.el.offsetHeight}px`;
      }
    }

    if (direction === 'up') {
      if (this.scrollPosition === 0) {
        stickyMenu.style.position = null;
        stickyMenu.style.top = `-${this.el.offsetHeight}px`;
      } else if (stickyMenu.classList.contains('header__inner--hidden')) {
        stickyMenu.classList.remove('header__inner--hidden');
        stickyMenu.style.top = 0;
      }
    }
  }

  handleSubmenuOpen(e) {
    if (this.breakpoint.matches) return;
    document
      .querySelectorAll('.primary-navigation__main-link--is-open')
      .forEach(opened => {
        opened.classList.remove('primary-navigation__main-link--is-open');
      });
    e.target.parentNode.classList.add('primary-navigation__main-link--is-open');
  }

  handleSubmenuClose(e) {
    if (this.breakpoint.matches) return;
    e.currentTarget.classList.remove('primary-navigation__main-link--is-open');
  }

  handleSubmenuKeydown(e) {
    const { activeElement } = document;
    const submenu = e.currentTarget.querySelector(
      '.primary-navigation__submenu'
    );
    const links = submenu.querySelectorAll('a');

    /* eslint-disable indent */
    switch (e.keyCode) {
      case keyCode.TAB:
        return this.handleSubmenuClose(e);
      case keyCode.DOWN:
        e.preventDefault();

        if (activeElement.classList.contains('primary-navigation__label')) {
          links[0].focus();
        } else if (
          e.target.parentNode.nextElementSibling &&
          !e.target.parentNode.nextElementSibling.classList.contains(
            'primary-navigation__view-all'
          )
        ) {
          e.target.parentNode.nextElementSibling.firstElementChild.focus();
        } else {
          links[0].focus();
        }
        break;
      case keyCode.UP:
        e.preventDefault();

        if (activeElement.classList.contains('primary-navigation__label')) {
          links[links.length - 2].focus();
        } else if (e.target.parentNode.previousElementSibling) {
          e.target.parentNode.previousElementSibling.firstElementChild.focus();
        } else {
          links[links.length - 2].focus();
        }
        break;
    }
    /* eslint-enable indent */
  }

  handleMobleMenuOpen() {
    this.scroll = window.scrollY;
    this.dom.primaryNavigation.style.maxHeight = `${window.innerHeight - 59}px`;
    document.body.style.top = `-${this.scroll}px`;
    document.body.classList.add('body--mobile-menu');
  }

  handleMobleMenuClose() {
    document.body.classList.remove('body--mobile-menu');
    window.scrollTo(0, this.scroll);

    setTimeout(() => {
      this.scrollPosition = this.scroll + 1;
      this.handleScroll();
    });
  }

  handleMobileSubmenuToggle(e) {
    if (this.breakpoint.matches) {
      e.preventDefault();

      const submenu = e.target.nextElementSibling;
      if (
        submenu.parentNode.classList.contains(
          'primary-navigation__main-link--is-mobile-open'
        )
      ) {
        close({
          element: submenu
        });
        submenu.parentNode.classList.remove(
          'primary-navigation__main-link--is-mobile-open'
        );
      } else {
        submenu.parentNode.classList.add(
          'primary-navigation__main-link--is-mobile-open'
        );
        open({ element: submenu });
      }
    }
  }

  handleSearchOpen() {
    this.timeline = gsap.timeline({
      onComplete: () => {
        if (this.dom.searchInput) {
          this.dom.searchInput.focus();
        }
      }
    });
    this.timeline.to(this.dom.mainLinks, {
      opacity: 0,
      duration: 0.2,
      onComplete: () => {
        this.dom.mainLinks.style.visibility = 'hidden';
      }
    });
    this.timeline.to(this.dom.searchArea, {
      width: '100%',
      display: 'flex',
      duration: 0.4
    });

    this.dom.openSearch.style.display = 'none';
    this.dom.closeSearch.style.display = 'flex';
  }

  handleSearchClose() {
    this.timeline = gsap.timeline({
      onComplete: () => {
        this.dom.openSearch.focus();
      }
    });

    this.timeline.to(this.dom.searchArea, {
      width: 0,
      display: 'none',
      duration: 0.2
    });
    this.dom.mainLinks.style.visibility = null;
    this.timeline.to(this.dom.mainLinks, {
      opacity: 1,
      duration: 0.2
    });

    this.dom.closeSearch.style.display = 'none';
    this.dom.openSearch.style.display = 'flex';
  }

  handleInputKeyPress(e) {
    if (e.keyCode === keyCode.ESC) {
      e.preventDefault();
      this.handleSearchClose();
    }
  }

  async handleLogOut(e) {
    e.preventDefault();
    try {
      const response = await Axios.get(this.logoutEndpoint);

      if (response) {
        window.location.href = '/';
        return false;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
}

export default Module;
